import { render, staticRenderFns } from "./paymentDetails.vue?vue&type=template&id=5bb65c83&scoped=true"
import script from "./paymentDetails.vue?vue&type=script&lang=js"
export * from "./paymentDetails.vue?vue&type=script&lang=js"
import style0 from "./paymentDetails.vue?vue&type=style&index=0&id=5bb65c83&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bb65c83",
  null
  
)

export default component.exports